import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);
Vue.config.productionTip = false;

import App from './App.vue';

import router from './router';

import storage from './services/storage';

storage.events = new Vue();
storage.states.activeScrollSection = null;
storage.states.breakpoints = {
    maxWidth767 : false,
    maxWidth959 : false,
    maxWidth1439 : false,
    maxHeight511 : false,
    maxHeight767 : false,
};
storage.states.isScrolling = false;
storage.states.menuIsVisible = false;
storage.states.googleMapsConsentGiven = false;
storage.states.scrollSections = {
    '#unser-portfolio' : 0,
    // '#erkunden-sie-uns' : 0,
    '#wer-wir-sind' : 0,
    '#dafuer-stehen-wir' : 0,
    '#was-wir-fuer-sie-tun-koennen' : 0,
    '#statements-unserer-kunden' : 0,
    '#unsere-referenzen' : 0,
    '#unsere-familie' : 0,
    '#unsere-hotline' : 0,
};

import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
    // autoTracking : {
    //     pageviewOnLoad : false,
    // },
    disabled : true,
    id : 'UA-93260698-9',
    router,
});

import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps);

let googleMapsInitialized = false;
const initGoogleMaps = ()=>{
    if (googleMapsInitialized) {
        return;
    }
    googleMapsInitialized = true;
    VueGoogleMaps.loadGmapApi({
        key : 'AIzaSyCAsKmGvmNGL-eq5_V0YvWKLjsFgFYBwg8',
    });
};

new Vue({
    data : {
        cache : storage.cache,
        events : storage.events,
        global : storage.global,
        messages : storage.messages,
        promises : storage.promises,
        states : storage.states,
        translations : storage.translations,
    },
    router,
    render : h=>h(App),
}).$mount('#app');

const checkCookiebotConsent = ()=>{
    if (window.Cookiebot) {
        if (window.Cookiebot.consent.marketing) {
            window.console.log('Cookiebot consent marketing: true');
            Vue.$ga.enable();
            initGoogleMaps();
            storage.states.googleMapsConsentGiven = true;
        } else {
            window.console.log('Cookiebot consent marketing: false');
            Vue.$ga.disable();
            storage.states.googleMapsConsentGiven = false;
        }
    }
};

window.addEventListener('CookiebotOnAccept', function(){
    window.console.log('CookiebotOnAccept', window.Cookiebot);
    checkCookiebotConsent();
}, false);

window.addEventListener('CookiebotOnDecline', function(){
    window.console.log('CookiebotOnDecline');
    Vue.$ga.disable();
    storage.states.googleMapsConsentGiven = false;
}, false);

checkCookiebotConsent();
